import React, { Component } from 'react';
import style from '../../style/style';

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      lines: 1
    };
  }

  expandText = () => {
    this.setState({
      lines: 100
    });
  }

  renderBars = () => {
    if (this.props.data) {
      let bars = [];
      const data = this.props.data;
      const total = parseInt(data[this.props.total]);
      const verb = this.props.verb ? this.props.verb : '';

      const sortedArr = this.props.fields.sort( (a, b) => {
        return parseInt(data[b.value]) - parseInt(data[a.value])
      });
      
      sortedArr.forEach(function (field, index) {
          const value = parseInt(data[field.value]);
          const title = field.name;
          const text = `${ value } ${ (value !== 1) ? verb : '' } ${ title }`;
          
          (value !== 0) &&
            bars.push(
              <div key={ title } 
                style={{ 
                  display: (!this.state.showMore && index > 7) ? "none" : "flex",
                  marginBottom: "1rem",
                  position: "relative",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    position: "relative",
                    zIndex: 1,
                    padding: "0 1rem",
                    fontWeight: 500,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                  }}
                  title={ text }
                  >
                  { text }
                </div>
                <div 
                  style={{ width: value ? Math.round((value / total) * 100) + "%" : 0, 
                  background: `hsla(240, ${Math.round((value / total) * 300)}%, 85%, 1)`,
                  height: "100%",
                  borderRadius: "16px",
                  position: "absolute",
                  top: "0"
                }}>
                </div>
              </div>
            );
          
      }.bind(this));
      return bars;
    }
    return;
  }

  showMore = () => {
    this.setState({
      showMore: true
    })
  }

  render() {

    const bars = this.renderBars();
    return (
      <div>
         { bars }
         {
           (!this.state.showMore && bars.length > 8) && <button
           style={{
              ...style.lightButton,
              background: "aliceblue",
              color: "blue"
           }} 
           onClick={this.showMore}>Show more...</button>
         }
      </div>
    );
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/barchart/index.js